import React, {useEffect, useRef, useState} from 'react';
import {frycooks,bg,fryCookHeader,video ,noCookLink,mintBtn,noCooksTextContainer,sadFaceContainer,noCooksText, mintAdopt,errorText,errorBtn,selectedAmt,hideRedeemedLabel,hideRedeemedContainer,numSelectedContainer, noCooksContainer,spinnerContainer,btnDisabled ,incrementBtn, mint, remaining} from '../styles/layout/frycooks/index.module.scss'
import {ingMarketStatus, closedRed} from '../styles/layout/ingredients/index.module.scss';
import vid from '../images/BURGERCARD.mp4';
import Spinner from '../components/base/svg/spinner';
import {cookList,closedRedBorder,mintClosed,availText,cookListWrapper,cookListItemWrapper,burgerList} from '../styles/layout/burgerredeem/index.module.scss';
import IngCard from '../components/base/ingCard';
import BlankCard from '../components/base/ingCard/blankIngCard';
import {INGREDIENTS_ABI, INGREDIENTS_ADDRESS, COOKS_ADDRESS, SUDOBURGERS_ADDRESS, SUDOBURGERS_ABI} from  '../constants/contractAddr'
import {Link} from 'gatsby';
import Frown from '../components/base/svg/frown';
import BurgerBuilderBlock from '../components/base/burgerBuilderBlock';

declare global {
    interface Window { 
    Web3: any;
    ethereum: any
    web3: any
    }
  }

  const MARKET_STATUS = {
    OPEN: "open",
    CLOSED: "closed",
    LOADING: "loading",
    ERROR: "error loading check wallet settings and refresh"
  }

const CookRedeem = ()=> {

  const WalletErrors = {
    NO_WEB3: "Error loading Web3",
    NETWORK_ERROR: "Network error try again",
    METAMASK_CONNECT_ERROR: "Error connecting to Metamask",
    NO_WALLET_AVAILABLE: "No wallet available",
    UNKNOWN_ERROR: "Unknown error refresh and try again",
    PROVIDER_NO_CHAIN_CONNECT: "Web3 provider not connected to chain",
    ADOPT_ERROR: "Couldn't mint verify you have enough eth to cover gas fees",
    NO_MAINNET: "Not connected to Mainnet",
    CONTRACT_INTERACTION_ERROR: "Contract interaction error",
    ERROR_FETCHING_MARKET: "Error fetching kitchen  status, please refresh"

};

const ADOPT_STATE = {
  ADOPTING: "adopting",
  ADOPTED: "adopted",
}
   
      interface walletState {
        address: string | null;
        network: string | null;
        errorMessage: string | null;
        jabbas: any[];
        web3Loaded: boolean;
        totalSupply: number | null;
        readyToPurchase: boolean;
        adoptState: string|null;
        selectedJabbas: any
        loading: boolean
        sudoPass: any[]
        hideSelected: boolean,
        marketOpen: string
      }
      
      
      const initialWalletState = {
          address: null,
          network: null,
          errorMessage: null,
          jabbas: [],
          sudoPass: [],
          web3Loaded: false,
          totalSupply: null,
          readyToPurchase: false,
          adoptState: null,
          selectedJabbas: [],
          loading: true,
          hideSelected: false,
          marketOpen: MARKET_STATUS.LOADING
        }
      

    const [walletState, setWalletState] = useState<walletState>(initialWalletState);


    const videoRef = useRef<HTMLVideoElement>(null);


    const requireWeb3 = () => {

      return new Promise<void>((resolve, reject)=> {
        if('web3' in window && 'ethereum' in window){
          if(window.ethereum.isConnected()){
            resolve();
          }else {
            reject(WalletErrors.PROVIDER_NO_CHAIN_CONNECT)
          }
      }else{
          reject(WalletErrors.NO_WEB3);
      }
      })
    };

    const  getNetwork = () => {
        return new Promise<string>((resolve, reject) => {
         window.ethereum.request({ method: 'eth_chainId' }) .then((response:string) => {

            let networkString = "";

            switch(response){
              case "0x1": {networkString="Mainnet"; break;}
              case "0x3": {networkString="Ropsten Test Network"; break;}
              case "0x4": {networkString="Rinkeby Test Network"; break;}
              case "0x5": {networkString="Goerli Test Network"; break;}
              case "0x2a": {networkString="Kovan Test Network"; break;}
              default: {networkString=""; break;}
            }
            setWalletState(prevState => ({...prevState, network:networkString}))
            
            if(networkString !="Mainnet"){
             reject(WalletErrors.NO_MAINNET)
            }

            resolve(networkString)}).catch(()=>{
                        reject(WalletErrors.NETWORK_ERROR);
            })
        })
      }
    

    const connectMetaMask =  (network:string)=> {
        return new Promise<string>((resolve, reject)=>{
        if (window.ethereum) {
           window.ethereum.request({ method: 'eth_requestAccounts' }).then(()=>{
            if(window.ethereum.selectedAddress){
              resolve(network);
            }else{
              reject(WalletErrors.NO_WALLET_AVAILABLE);
            }
           }).catch(()=>{
             reject(WalletErrors.METAMASK_CONNECT_ERROR);
           })
        } else {
          reject(WalletErrors.NO_WALLET_AVAILABLE);
        }
        });      
    }

 
    const updateWalletInfo = (network:string) => {
      return new Promise<string>((resolve,reject)=>{
        if(window.ethereum.selectedAddress){
            setWalletState( prevState =>({...prevState,address: window.ethereum.selectedAddress, readyToPurchase:true}))
        } else {
          reject(WalletErrors.NO_WALLET_AVAILABLE)
        }
        resolve(network);
      });
    };




    const play = ()=> {
      videoRef.current?.play();
    };



    const loadNfts = (network:string) => {

        return new Promise<string>(async (resolve,reject)=>{
          try {
            const ingContract = new window.web3.eth.Contract(INGREDIENTS_ABI, INGREDIENTS_ADDRESS)
  
            const numIng = await ingContract.methods.tokensOfOwner(window.ethereum.selectedAddress).call()
            numIng.map((currentIngId:string) => {
              ingContract.methods.uri(currentIngId).call().then((uri:string)=>{
              fetch(uri).then(res => res.json()).then((json:any)=>{
                  setWalletState(prevState => {
                  const jabbas = [...prevState.jabbas];
                  const category = json.attributes.find((attr: {key:string}) => attr.key === "CATEGORY");
                  jabbas.push({image: json.image, meshId: json.meshId, category: category.value, id: currentIngId});
                  return {...prevState, jabbas, errorMessage:null, loading:false}
                } )
                });
              })
            });
  
            resolve(network);
          } catch (error) {
            if(network !="Mainnet"){
              console.log(error)
             reject(WalletErrors.NO_MAINNET)
            }else{
              console.log(error)
              reject(WalletErrors.CONTRACT_INTERACTION_ERROR);
            }
          }
        });
      };
  

    const loadUser =()=>{
    return requireWeb3()
      .then(getNetwork)
      .then(connectMetaMask)
      .then(updateWalletInfo)
      .then(fetchMarketStatus)
      .then(loadNfts)
      .catch((e)=> {setWalletState(prevState => ({...prevState, errorMessage: e, readyToPurchase:false, loading:false, marketOpen: MARKET_STATUS.ERROR}))})
};

    useEffect(()=>{
      const loadFn = () => {
        setWalletState(prevState => ({...prevState, web3Loaded: true}))
       }
       if('web3' in window && 'ethereum' in window){
        loadFn();
      }else{
        const script = document.getElementById("web3")!;
        script.addEventListener('load',loadFn)
      }
    },[]);

    useEffect(()=>{
      if (walletState.web3Loaded && window.ethereum) {
            if(window.Web3 && window.Web3.givenProvider){
            window.web3 = new window.Web3(window.Web3.givenProvider)
            loadUser();
      
            window.ethereum.on('accountsChanged', ()=> {
              console.log("ACCOUNT CHANGED")
              setWalletState(prevState=>({...prevState, errorMessage:null}))
             loadUser();
            })

            window.ethereum.on('chainChanged', ()=> {
              console.log("CHAIN CHANGED")
              setWalletState(prevState=>({...prevState, errorMessage:null}))
             loadUser();
            })
          }else{
            setWalletState(prevState =>({...prevState, errorMessage:WalletErrors.NO_WEB3}))
          }
      }
    },[walletState.web3Loaded]);


    const toggleSelectedJabbas = (selected: any)=> {
      setWalletState(prevState =>
        {
          const current = prevState.selectedJabbas.find((jabba: {id:string}) => jabba.id === selected)
          
          if(current){
              const selectedJabbas = [...prevState.selectedJabbas];
              const jabbas = [...prevState.jabbas];
              const index = selectedJabbas.indexOf(current);
              selectedJabbas.splice(index,1);
              jabbas.push(current);
              return {...prevState, selectedJabbas, jabbas}
          }
          else{
            const selectedJabbas = [...prevState.selectedJabbas];
            const jabbas = [...prevState.jabbas];
            if(prevState.selectedJabbas.length <= 32){
            const currentFromJabbas = jabbas.find((jabba: {id:string}) => jabba.id === selected)
            const indexFromJabbas = jabbas.indexOf(currentFromJabbas);
            jabbas.splice(indexFromJabbas,1);
            selectedJabbas.push(currentFromJabbas);
            }
            return {...prevState, selectedJabbas, jabbas}
          }
        })
        
    }
    const resetSpinner = ()=>{
      setWalletState(prevState =>({...prevState, adoptState:null}))
    };



    const purchaseNFT = async ()=>{
      try{
        setWalletState(prevstate =>({...prevstate, errorMessage:null, adoptState:ADOPT_STATE.ADOPTING}))
        const ingContract = new window.web3.eth.Contract(INGREDIENTS_ABI, INGREDIENTS_ADDRESS)
  
        const {selectedJabbas} = walletState;


       const ids = selectedJabbas.map((jabba: {id:string})=>(jabba.id)).reverse();

       console.log(ids, selectedJabbas);
    
        const transactionParameters = {
          to: INGREDIENTS_ADDRESS,
          from: window.ethereum.selectedAddress 
        };

       await ingContract.methods.grillBurger(ids).send(transactionParameters)
        setWalletState(prevstate =>({...prevstate, errorMessage:null, selectedJabbas:[] ,adoptState:ADOPT_STATE.ADOPTED}))
      

      }catch(e:any){
        if(e.code && e.code ==4001){
          setWalletState(prevState => ({...prevState, adoptState:null}))
        }else{
          console.log(e)
          setWalletState(prevState => ({...prevState, errorMessage: WalletErrors.ADOPT_ERROR, adoptState:null}))
        }
      }
    }

    const fetchMarketStatus = () => {
      return new Promise<string>(async (resolve,reject)=> {
        try {
          const ingContract = new window.web3.eth.Contract(INGREDIENTS_ABI, INGREDIENTS_ADDRESS)

          const isMarketOpen = await ingContract.methods.getKitchen().call()
          
          const marketOpen = isMarketOpen ? MARKET_STATUS.OPEN : MARKET_STATUS.CLOSED;
          
          setWalletState(prevState => ({...prevState, marketOpen}))
          resolve(marketOpen);
          
        } catch (error) {
          console.log(error)
          reject(WalletErrors.ERROR_FETCHING_MARKET)
        }
      })
    };


    useEffect(()=>{
       play();
    },[]);

    return (
        <>
        <div className={bg}>
        <video
                 ref={videoRef}
                 className={video}
                 loop
                 muted={true}
                 playsInline={true}
               >
                <source src={vid} type="video/mp4" />
               </video>         </div>
         <div className={frycooks}>
            <h2 className={fryCookHeader}>Sudoburgers</h2>
            <h6 className={`${ingMarketStatus} ${walletState.marketOpen === MARKET_STATUS.CLOSED || walletState.marketOpen === MARKET_STATUS.CLOSED  ?   closedRed : ""}`}>Kitchen Status:</h6>
                <h6 className={`${ingMarketStatus} ${walletState.marketOpen === MARKET_STATUS.CLOSED || walletState.marketOpen === MARKET_STATUS.ERROR  ? closedRed : ""}`}>{walletState.marketOpen}</h6>
                <p>Choose between 3 to 32 ingredients to build your burger!</p>
              {!walletState.errorMessage && !walletState.loading  && walletState.jabbas.length + walletState.selectedJabbas.length === 0 &&  <div className={noCooksContainer}> 
                <div className={sadFaceContainer}>
                  <Frown className={""}/>
                </div>  
                <div className={noCooksTextContainer}>
                    <p className={noCooksText}>No Ingredients found in wallet!</p>
                    <Link className={noCookLink} to="/ingredients">Mint Ingredients</Link>
                </div>
              </div>}

                {walletState.loading && <div className={spinnerContainer}><Spinner resetSpinner={()=>{}} adoptState={"adopting"} /></div>}
               <div className={cookListWrapper}>
                 <div className={cookListItemWrapper}>
                    <p className={availText}>Available</p>
                  <div className={`${cookList} ${walletState.marketOpen === MARKET_STATUS.CLOSED ? closedRedBorder : ""}`}>  
                  {walletState.jabbas.map((item: {meshId:string, image:string, category:any, id:string}, index) =>  
                  {
                    return(<IngCard disabled={walletState.adoptState === ADOPT_STATE.ADOPTING} onClick={()=>{toggleSelectedJabbas(item.id)}} key={index} text={item.meshId} pos={""} redeemed={false} selected={false} src={item.image}/>)})}
                  {walletState.jabbas.length === 0 && <BlankCard/>}
            </div>
                 </div>
           <div className={cookListItemWrapper}>
           <p className={availText}>Selected</p>
           <div className={`${cookList} ${walletState.marketOpen === MARKET_STATUS.CLOSED ? closedRedBorder : ""}`}>  
              {walletState.selectedJabbas.map((item: {meshId:string, image:string, id:string}, index:number) => (<IngCard disabled={walletState.adoptState === ADOPT_STATE.ADOPTING} onClick={()=>{toggleSelectedJabbas(item.id)}} key={index} text={item.meshId} pos={""} redeemed={false} selected={false} src={item.image}/>))}
                {walletState.selectedJabbas.length === 0 && <BlankCard/>}
            </div>

           </div>
      
            <div className={burgerList}>
            {walletState.selectedJabbas.map((item: {meshId:string, image:string, category: string}, index:number)=> (<BurgerBuilderBlock key={index} title={item.meshId} type={item.category}/>))}
            {walletState.selectedJabbas.length === 0 && <BlankCard/>}
            </div>
               </div>
            {!walletState.loading && walletState.selectedJabbas.length < 33 &&
            <button disabled={walletState.selectedJabbas.length < 3 || !walletState.readyToPurchase || !!walletState.adoptState || walletState.marketOpen === MARKET_STATUS.CLOSED} onClick={purchaseNFT}  className={`${incrementBtn} ${mintBtn} ${!walletState.readyToPurchase ? btnDisabled : ""}`}>
                <p className={`${mint} ${!!walletState.adoptState ? mintAdopt : ""} ${walletState.marketOpen === MARKET_STATUS.CLOSED ? mintClosed :""}`}>Mint!</p>
                <Spinner resetSpinner={resetSpinner} adoptState={walletState.adoptState} />
            </button>
            }
            {walletState.errorMessage &&
              <>  
                <p className={errorText}>{walletState.errorMessage}</p>
                <p className={errorText}>Verfify your wallet settings and click <span><button onClick={loadUser} className={errorBtn}>here</button></span> to reconnect</p>
              </>}    
        </div>
        </>
    );
};


export default CookRedeem;


// /*
//       {/*START*/}
//       <Container
//       placeholderClass="dragging"
//       initialState={{
//         available: [1,2,3,4,5,6,7,8,9,10],
//         selected: [11,12,13,14,15,16],

//       }}
//     >
//       {({
//         state: {
//           values,
//           dragState: { moveType }
//         }
//       }) => {
//         return (
//             <div className="content">
//               <div className="horizontal_wrapper">
//                 <Droppable name="available">
//                   {() => (
//                     <div className="horizontal_droppable">
//                       {values.available.map((src, index) => {
//                         return (
//                           <Draggable index={index} key={src}>
//                             {({ dragging }) => (
//                               <img
//                                 className={`horizontal_img draggable ${
//                                   dragging && moveType === "keyboard"
//                                     ? "dragging"
//                                     : ""
//                                 }`}
//                                 src={'data:image/jpeg;base64,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'}
//                               />
//                             )}
//                           </Draggable>
//                         );
//                       })}
//                     </div>
//                   )}
//                 </Droppable>
//               </div> 

//               <div className="horizontal_wrapper">
//                 <Droppable name="selected">
//                   {() => (
//                     <div className="horizontal_droppable">
//                       {values.selected.map((src, index) => {
//                         return (
//                           <Draggable index={index} key={src}>
//                             {({ dragging }) => (
//                               <img
//                                 className={`horizontal_img draggable ${
//                                   dragging && moveType === "keyboard"
//                                     ? "dragging"
//                                     : ""
//                                 }`}
//                                 src={'data:image/jpeg;base64,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'}
//                               />
//                             )}
//                           </Draggable>
//                         );
//                       })}
//                     </div>
//                   )}
//                 </Droppable>
//               </div> 
//             </div>
//         );
//       }}
//     </Container>



